import React from 'react';
import { Feedback } from '@plerionhq/design-system';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import timeZone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useOrganizationInfo } from '../../api/organization';
import { openServiceDeskChatOrEmail } from '../utils/serviceDesk';

import { useTranslation, Trans } from 'react-i18next';

dayjs.extend(relativeTime);
dayjs.extend(timeZone);
dayjs.extend(utc);

export const DisplayOrganizationDeleteInProgressBlock = () => {
  const { t } = useTranslation('containerInterface');
  const { data: orgData, isLoading: isOrganizationLoading } =
    useOrganizationInfo();
  if (isOrganizationLoading || !orgData) {
    return <></>;
  }

  const { profile } = orgData;
  const deleteTimeWithTimeZone = dayjs
    .tz(profile.deleteScheduledAt, dayjs.tz.guess())
    .format('MMMM D, YYYY h:mm A (Z)');

  const relativeTimeFromNow = dayjs(profile.deleteScheduledAt).fromNow();

  if (profile?.status === 'delete_in_progress') {
    return (
      <Feedback
        title={t('yourPlerionOrganizationHasBeenScheduledFor')}
        variant="error"
        dismissible
        wrapperClassName="!border-0 !rounded-none px-6"
      >
        <>
          <Trans
            t={t}
            i18nKey="yourPlerionOrganizationIsScheduledToBe"
            values={{ deleteTimeWithTimeZone, relativeTimeFromNow }}
            components={{
              strong: <strong />,
              button: (
                <button
                  onClick={(event) => {
                    openServiceDeskChatOrEmail();
                    event.preventDefault();
                  }}
                  className="text-base font-semibold underline"
                />
              ),
            }}
          />
        </>
      </Feedback>
    );
  }

  return <></>;
};
